module.exports = __webpack_public_path__ + "static/media/15.aab99f78.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/15.png
// module id = 932
// module chunks = 0